import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Swiper for non-auto-scroll sliders
  const allSliders = document.querySelectorAll('.cards-container.swiper');
  allSliders.forEach((container) => {
    const parentBlock = container.closest('.slider-cards');
    if (parentBlock?.classList.contains('slider-cards--auto-scroll')) {
      return; // Skip auto-scroll sliders
    }

    new Swiper(container, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 32,
      /* pagination: {
        el: ".pagination",
        renderBullet: function (index, className) {
          return `<span class="dot swiper-pagination-bullet">${index}</span>`;
        },
      },
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      }, */
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 64,
        },
      },
    });
  });

  // Handle auto-scroll sliders
  const autoScrollBlocks = document.querySelectorAll('.slider-cards--auto-scroll');
  autoScrollBlocks.forEach((block) => {
    const swiperContainer = block.querySelector('.cards-container.swiper');
    const swiperWrapper = block.querySelector('.swiper-wrapper');

    if (!swiperContainer || !swiperWrapper) return;

    // Initialize Swiper for auto-scroll sliders
    const swiperInstance = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 32,
      allowTouchMove: false,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 64,
        },
      },
    });

    // Update layout for sticky auto-scroll
    const updateLayout = () => {
      const slidersWidth = swiperWrapper.scrollWidth;
      const viewportHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const maxTranslateX = slidersWidth - windowWidth;
      const stickyHeight = maxTranslateX + viewportHeight;

      block.style.position = 'relative';
      block.style.height = `${stickyHeight}px`;

      swiperContainer.style.position = 'sticky';
      swiperContainer.style.top = '0';
      swiperContainer.style.left = '0';
      swiperContainer.style.width = '100%';

      // Prevent horizontal overflow
      swiperContainer.style.overflowX = 'hidden';
      document.body.style.overflowX = 'hidden';
    };

    // Scroll event handler
    const handleScroll = () => {
      const rect = block.getBoundingClientRect();
      const scrollTop = -rect.top;
      const maxScroll = block.offsetHeight - window.innerHeight;

      if (scrollTop >= 0 && scrollTop <= maxScroll) {
        const progress = scrollTop / maxScroll;
        const maxTranslateX = swiperWrapper.scrollWidth - window.innerWidth;
        const translateX = Math.min(progress * maxTranslateX, maxTranslateX);

        swiperInstance.setTranslate(-translateX); // Use Swiper to control translation
      } else if (scrollTop < 0) {
        swiperInstance.setTranslate(0);
      } else {
        const maxTranslateX = swiperWrapper.scrollWidth - window.innerWidth;
        swiperInstance.setTranslate(-maxTranslateX);
      }
    };

    // Initial layout update
    updateLayout();

    let resizeTimeout;
    window.addEventListener(
      'resize',
      () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          updateLayout();
          handleScroll();
        }, 150);
      },
      { passive: true }
    );

    let ticking = false;
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener(
      'orientationchange',
      () => {
        setTimeout(() => {
          updateLayout();
          handleScroll();
        }, 100);
      },
      { passive: true }
    );

    handleScroll(); // Trigger initial scroll handling
  });
});
